import { render, staticRenderFns } from "./MaintainTabData.vue?vue&type=template&id=3841423e&scoped=true"
import script from "./MaintainTabData.vue?vue&type=script&lang=js"
export * from "./MaintainTabData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3841423e",
  null
  
)

export default component.exports